
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/link/messaging",
      function () {
        return require("private-next-pages/docs/link/messaging.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/link/messaging"])
      });
    }
  